import * as yup from 'yup';

const schema = yup.object().shape({
  first_name: yup.string().required('This field is required'),
  last_name: yup.string().required('This field is required'),
  email: yup.string().email('Please enter a valid email format').required('This field is required'),
});

export default schema;
